<mat-card class="cardWithShadow">
  <mat-card-header class="d-flex">
    <button
      (click)="openHeaderDialog()"
      type="button"
      mat-stroked-button
      color="primary"
    >
      Agregar Usuarios
    </button>
  </mat-card-header>
  <mat-card-content>
    <div class="table-responsive m-t-30">
      <table mat-table [dataSource]="dataSource" class="w-100">
        <ng-container matColumnDef="firstName">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="f-w-600 f-s-16 mat-subtitle-1 p-l-0"
          >
            Nombre
          </th>
          <td mat-cell *matCellDef="let element" class="p-l-0">
            <div class="m-l-12">
              <h5 class="mat-subtitle-1 f-s-14 f-w-600 m-0">
                {{ element.firstName }}
              </h5>
              <span class="f-s-12">{{ element.lastName }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Project Name Column -->
        <ng-container matColumnDef="email">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="f-w-600 f-s-16 mat-subtitle-1"
          >
            Email
          </th>
          <td mat-cell *matCellDef="let element" class="f-s-14 m-0">
            {{ element.email }}
          </td>
        </ng-container>
        <ng-container matColumnDef="phone">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="f-w-600 f-s-16 mat-subtitle-1"
          >
            Numero
          </th>
          <td mat-cell *matCellDef="let element" class="f-s-14">
            {{ element.phone }}
          </td>
        </ng-container>

        <ng-container matColumnDef="roles">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="f-w-600 f-s-16 mat-subtitle-1"
          >
            Roles
          </th>
          <td mat-cell *matCellDef="let element" class="f-s-14">
            {{ element.roles }}
          </td>
        </ng-container>
        <ng-container matColumnDef="rut">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="f-w-600 f-s-16 mat-subtitle-1"
          >
            RUT
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.rut }}
          </td>
        </ng-container>
        <ng-container matColumnDef="icon">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="f-w-600 f-s-16 mat-subtitle-1"
          >
            Edicion
          </th>
          <td mat-cell *matCellDef="let element" class="grill f-s-14" style="padding: 20% 0;">
            <i-tabler              
              name="pencil"
              class="icon-20"
              style="cursor: pointer; "
              (click)="openEditDialog(element.rut)"
              matTooltip="Editar Usuario"
            ></i-tabler>
            <i-tabler              
              name="trash"
              style="cursor: pointer"
              class="icon-20"
              (click)="delete(element.rut)"
              matTooltip="Elimar Usuario"
            ></i-tabler>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]">
      </mat-paginator>
    </div>
  </mat-card-content>
</mat-card>
